import { Product } from "../../redux/types/productTypes";

interface IProductSchemaProps {
  product: Product;
}

export const ProductSchema: React.FC<IProductSchemaProps> = ({ product }) => {
  const schema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: product.productName,
    image: product.productImage,
    description: product.productDescriprion,
    // sku: product.sku,
    // mpn: product.mpn,
    // brand: {
    //   "@type": "Brand",
    //   name: product.brand,
    // },
    offers: {
      "@type": "Offer",
      url: product.productUrl,
      priceCurrency: "USD",
      price: product.price,
      //priceValidUntil: product.priceValidUntil,
      itemCondition:
        product.productCondition === "new"
          ? "https://schema.org/NewCondition"
          : "https://schema.org/UsedCondition",
      availability:
        product.productQuantity > 0
          ? "https://schema.org/InStock"
          : "https://schema.org/OutOfStock",
      //   seller: {
      //     "@type": "Organization",
      //     name: product.seller,
      //   },
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};
